import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import {
	type DirecionadaFormData,
	type DirecionadaInput,
	direcionadaSchema,
} from '../../schemas/direcionada-schema'

export function useDirecionadaForm() {
	return useForm<DirecionadaInput, Record<string, never>, DirecionadaFormData>({
		defaultValues: {
			date: '',
			quizId: '',
			comment: '',
			answers: [],
		},
		resolver: zodResolver(direcionadaSchema),
		shouldFocusError: true,
		mode: 'onSubmit',
	})
}
